module.exports = __webpack_public_path__ + "static/data-explorer-6150d889a92e14891767fed34e5fe0ec.png";